<template>
  <div>
    <form-accordion :title="$t('common.email.email_group')" :isTitleUpperCase="false">
      <b-row>
        <b-col sm="6" class="form-group" v-if="!readonly">
          <form-write-group-label-input v-model="GroupName" isMandatory
            :inputLabel="$t('common.email.group_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-else>
          <form-read-group-label-input isMandatory
          :inputLabel="$t('common.email.group_name')"
          :inputValue="GroupName">
          </form-read-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion :title="$t('common.email.email_address')" :isTitleUpperCase="false" v-if="mode === 'add'">
      <button class="btn w-auto px-4 btn-tertiary mb-5" @click.prevent="addEmailAddress">{{ $t('common.email.email_address_add') }}</button>
      <div class="rounded p-4 trackingAccordion mb-5" v-for="(emailAdd, index) in emailAddList" :key="index">
        <b-row>
          <b-col sm="6" class="form-group" v-if="!readonly">
            <form-write-group-label-input v-model="emailAdd.Name" isMandatory
              :inputLabel="$t('common.email.email_address_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-if="!readonly">
            <form-write-group-label-input v-model="emailAdd.Email" isMandatory
              :inputLabel="$t('common.email.email_address')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <button class="btn w-auto px-4 btn-tertiary" @click.prevent="removeEmailAddress(index, emailAdd)">{{ $t('common.email.email_address_delete') }}</button>
      </div>
    </form-accordion>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"

export default {
  name: "EmailGroupForm",
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          GroupName: '',
          emailAddList: []
        }
      }
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    GroupName: {
      get () {
        return this.inputValue.GroupName || ''
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          GroupName: val,
        }
      }
    },
    emailAddList: {
      get () {
        return this.inputValue.emailAddList || []
      },
      set (val) {
        this.inputValue = {
          ...this.inputValue,
          emailAddList: val,
        }
      }
    }
  },
  methods: {
    addEmailAddress () {
      const maxEmails = 10
        if (this.emailAddList.length >= maxEmails) {
          this.okMessageBox(this.$t('common.email.email_address_max_limit'))
          return
        }
      const newEmail = { Name: '', Email: '', id: null }
      const updatedList = [...this.emailAddList, newEmail]
      this.emailAddList = updatedList
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    removeEmailAddress (index, emailAdd) {
      if (emailAdd.id) {
        this.$engine.firstOn().email.emailAddress.delete({id: emailAdd.id})
      }
      this.emailAddList.splice(index , 1)
      this.emailAddList = updatedList
    }
  }
}
</script>
